export default __webpack_public_path__ + "static/media/phg.02fe6a40.png";